/**
 * 工资条模块 - Vuex Store
 */
const state = () => ({
    /** 当月工资条完整数据 */
    currentPayslip: null,
    /** 历史工资条列表 */
    historyList: [],
    /** 当前查看的工资条详情 */
    detail: null,
    /** 当前选中的年份 */
    selectedYear: new Date().getFullYear(),
    /** 金额是否显示（隐私保护） */
    amountVisible: false,
})

const getters = {
    /** 是否有当月工资条数据 */
    hasCurrentPayslip: (state) => {
        return state.currentPayslip !== null
    },
    /** 当前年月 */
    currentYearMonth: (state) => {
        if (!state.currentPayslip) return ''
        const { salaryYear, salaryMonth } = state.currentPayslip
        if (!salaryYear || !salaryMonth) return ''
        const m = String(salaryMonth).padStart(2, '0')
        return `${salaryYear}年${m}月`
    },
}

const mutations = {
    setCurrentPayslip(state, value) {
        state.currentPayslip = value
    },
    setHistoryList(state, value) {
        state.historyList = value
    },
    setDetail(state, value) {
        state.detail = value
    },
    setSelectedYear(state, value) {
        state.selectedYear = value
    },
    setAmountVisible(state, value) {
        state.amountVisible = value
    },
    toggleAmountVisible(state) {
        state.amountVisible = !state.amountVisible
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}
